import './hotspot.scss';

import { getOffset, smoothScrollTo } from '../../js/helper';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

require('../../images/vignette.png');

class Hotspot {
    constructor (element, options) {
        const defaults = {
            breakpoints: null,
            initAttr: 'data-hotspot',
            mediaAttr: 'media',
            introMediaAttr: 'intromedia',
            outroMediaAttr: 'outromedia',
            skipButtonAttr: 'skipbutton',
            overviewButtonAttr: 'overviewbutton',
            backButtonAttr: 'backbutton',
            chapterAttr: 'chapter',
            chapterMediaAttr: 'chaptermedia',
            chapterMarkerAttr: 'chaptermarker',
            contentAttr: 'content',
            contentMediaAttr: 'contentmedia',
            contentMarkerAttr: 'contentmarker',
            overlayButtonAttr: 'overlaybutton',
            overlayAttr: 'overlay',
            overlayCloseAttr: 'overlayclose',
            header: null,
            onOverviewLoaded: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$hotspot = element;
        this.$$hotspotMedias = this.$hotspot.querySelectorAll('video');
        this.$hotspotMedia = this.$hotspot.querySelector('[' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"]');
        this.$hotspotIntroMedia = this.$hotspot.querySelector('[' + this.settings.initAttr + '="' + this.settings.introMediaAttr + '"]');
        this.$hotspotOutroMedia = this.$hotspot.querySelector('[' + this.settings.initAttr + '="' + this.settings.outroMediaAttr + '"]');
        this.$hotspotSkipButton = this.$hotspot.querySelector('[' + this.settings.initAttr + '="' + this.settings.skipButtonAttr + '"]');
        this.$$hotspotChapters = this.$hotspot.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.chapterAttr + '"]');
        this.$$hotspotContents = this.$hotspot.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');

        this.$previousElement = this.$hotspot.previousElementSibling;

        if (this.settings.header !== null) {
            this.$header = this.settings.header;
        }

        if (this.$previousElement !== null) {
            if (this.$previousElement.getAttribute('data-videointro') !== null) {
                this.$videoIntro = this.$previousElement;
            }
        }

        if (this.$$hotspotMedias === null) {
            console.error('no elements found with ' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"');
            return;
        }

        if (this.$$hotspotChapters.length !== 0) {
            this.setChapterMarkers();
        }

        this.videos = [];

        for (let i = 0; i < this.$$hotspotMedias.length; i++) {
            const $hotspotMedia = this.$$hotspotMedias[i];

            if ($hotspotMedia.src !== '') {
                this.videos.push($hotspotMedia);
            }
        }
    }

    initialize () {
        let loadedElements = 0;

        const checkVideo = (videoElement) => {
            videoElement.play();
            const b = setInterval(() => {
                if (videoElement.readyState >= 1) {
                    videoElement.pause();

                    loadedElements++;

                    clearInterval(b);
                }
            }, 500);
        };

        const preloadVideos = (videos, callback) => {
            for (let i = 0; i < videos.length; i++) {
                checkVideo(videos[i]);
            }

            const loaderInterval = window.setInterval(() => {
                if (videos.length === loadedElements) {
                    clearInterval(loaderInterval);
                    callback();
                }
            }, 500);
        };

        this.$hotspot.classList.add('is--ready');

        if (window.Modernizr.ie11) {
            this.setEvents();
        } else {
            preloadVideos(this.videos, () => {
                this.setEvents();
            });
        }
    }

    setEvents () {
        this.$hotspotSkipButton.addEventListener('click', () => {
            this.$videoIntro.parentNode.removeChild(this.$videoIntro);
            this.initImages();
            this.showIntro();
        });

        window.addEventListener('video-intro-ended', () => {
            this.$videoIntro.parentNode.removeChild(this.$videoIntro);
            this.initImages();
            this.showIntro();
        });

        this.$hotspotIntroMedia.addEventListener('play', () => {
            this.$hotspotOutroMedia.currentTime = 0;

            window.setTimeout(() => {
                this.$hotspot.classList.add('show--intro');
            }, 500);
        });

        this.$hotspotIntroMedia.addEventListener('ended', () => {
            this.$hotspot.classList.add('show--intro-headline');
            this.$hotspot.classList.add('show--intro-marker');

            if (this.checkSize() === 'desktop') {
                this.$hotspotIntroMedia.classList.add('is--hidden');
                this.$hotspotOutroMedia.classList.remove('is--hidden');
            }
        });

        this.$hotspotOutroMedia.addEventListener('play', () => {
            this.$hotspotIntroMedia.currentTime = 0;
        });

        this.$hotspotOutroMedia.addEventListener('ended', () => {
            if (this.checkSize() === 'desktop') {
                this.$hotspotOutroMedia.classList.add('is--hidden');
                this.$hotspotIntroMedia.classList.remove('is--hidden');
            }

            this.$hotspot.classList.remove('show--intro');
        });
    }

    loadAndPlayVideo ($video) {
        const playPromise = $video.play();

        if (playPromise !== undefined) {
            playPromise
                .then(() => {
                    console.log('play video');
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    checkSize () {
        if (typeof this.settings.breakpoints.l !== 'undefined' && window.innerWidth >= this.settings.breakpoints.l) {
            return 'desktop';
        } else {
            return 'mobile';
        }
    }

    setChapterMarkers () {
        for (let i = 0; i < this.$$hotspotChapters.length; i++) {
            const $currentChapter = this.$$hotspotChapters[i];
            const $hotspotChapter = $currentChapter.querySelector('[' + this.settings.initAttr + '="' + this.settings.chapterMarkerAttr + '"]');
            const hotspotTitle = $hotspotChapter.innerHTML;
            const hotspotPosition = $hotspotChapter.getAttribute(this.settings.initAttr + 'position').split('|');
            const hotspotId = $hotspotChapter.getAttribute('id');
            const $overviewButton = $currentChapter.querySelector('[' + this.settings.initAttr + '="' + this.settings.overviewButtonAttr + '"]');
            const hotspotPositionX = 100 / (1440 / 100 * 75) * hotspotPosition[0];
            const hotspotPositionY = 100 / (810 / 100 * 75) * hotspotPosition[1];
            const $hotspotMarker = document.createElement('a');

            $hotspotMarker.innerHTML = '<i>' + hotspotTitle + '</i>';
            $hotspotMarker.classList.add('marker');

            $hotspotMarker.setAttribute('href', '#' + hotspotId);
            $hotspotMarker.setAttribute('style', 'left: ' + hotspotPositionX + '%; top: ' + hotspotPositionY + '%; transition-delay: ' + ((i + 1) * 0.25) + 's;');

            this.$hotspotMedia.querySelector('span').appendChild($hotspotMarker);

            $hotspotMarker.addEventListener('click', (e) => {
                if (this.checkSize() === 'desktop') {
                    e.preventDefault();
                    this.showOutro(() => {
                        this.showChapterOverview($currentChapter);
                    });
                } else {
                    e.preventDefault();
                    this.showChapterOverview($currentChapter);

                    const position = getOffset($currentChapter);
                    smoothScrollTo(0, position.top, 250);
                }

                const animateOnClickElements = document.querySelectorAll('.text-animate-on-click');
                for (let j = 0; j < animateOnClickElements.length; j++) {
                    const animateElement = animateOnClickElements[j];
                    animateElement.classList.remove('animate');
                    animateElement.style.transform = 'translateY(50px)';
                    animateElement.style.opacity = '0';
                }
            });

            $overviewButton.addEventListener('click', (e) => {
                this.hideChapterOverview($currentChapter);
                e.preventDefault();
            });

            this.setContentMarkers($currentChapter);
        }
    }

    setContentMarkers ($currentChapter) {
        const $$chapterContents = $currentChapter.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        const $chapterMedia = $currentChapter.querySelector('[' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"]');

        if ($chapterMedia !== null) {
            for (let i = 0; i < $$chapterContents.length; i++) {
                const $currentContent = $$chapterContents[i];
                const $hotspotContent = $currentContent.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentMarkerAttr + '"]');
                const hotspotTitle = $hotspotContent.innerHTML;
                const hotspotPosition = $hotspotContent.getAttribute(this.settings.initAttr + 'position').split('|');
                const hotspotId = $hotspotContent.getAttribute('id');
                const $backButton = $currentContent.querySelector('[' + this.settings.initAttr + '="' + this.settings.backButtonAttr + '"]');
                const $overlayButton = $currentContent.querySelector('[' + this.settings.initAttr + '="' + this.settings.overlayButtonAttr + '"]');
                const $overlayCloseButton = $currentContent.querySelector('[' + this.settings.initAttr + '="' + this.settings.overlayCloseAttr + '"]');
                const $overlay = $currentContent.querySelector('[' + this.settings.initAttr + '="' + this.settings.overlayAttr + '"]');
                const hotspotPositionX = 100 / 800 * hotspotPosition[0];
                const hotspotPositionY = 100 / 800 * hotspotPosition[1];
                const $hotspotMarker = document.createElement('a');

                $hotspotMarker.innerHTML = '<i>' + hotspotTitle + '</i>';

                $hotspotMarker.classList.add('marker');

                $hotspotMarker.setAttribute('href', '#' + hotspotId);
                $hotspotMarker.setAttribute('style', 'left: ' + hotspotPositionX + '%; top: ' + hotspotPositionY + '%; transition-delay: ' + (1 + (i + 1) * 0.25) + 's;');

                $chapterMedia.querySelector('span').appendChild($hotspotMarker);

                $hotspotMarker.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (this.checkSize() === 'mobile') {
                        const position = getOffset($currentContent);
                        smoothScrollTo(0, position.top, 250);
                    } else {
                        this.showChapterContent($currentChapter, $currentContent);
                    }
                });

                $backButton.addEventListener('click', (e) => {
                    this.hideChapterContent($currentChapter, $currentContent, true);
                    e.preventDefault();
                });

                if ($overlayButton !== null) {
                    $overlayButton.addEventListener('click', () => {
                        $currentContent.classList.add('is--out');

                        if (this.$header !== null) {
                            this.$header.classList.add('has--overlay');
                        }

                        window.setTimeout(() => {
                            $currentContent.classList.add('show--overlay');
                            $overlay.classList.add('is--in');
                            disableBodyScroll($overlay);
                        }, 500);
                    });
                }

                if ($overlayCloseButton !== null) {
                    $overlayCloseButton.addEventListener('click', () => {
                        $overlay.classList.add('is--out');
                        $currentContent.classList.remove('show--overlay');

                        window.setTimeout(() => {
                            $currentContent.classList.remove('is--out');
                            $overlay.classList.remove('is--out');
                            $overlay.classList.remove('is--in');
                            enableBodyScroll($overlay);

                            if (this.$header !== null) {
                                this.$header.classList.remove('has--overlay');
                            }
                        }, 500);
                    });
                }
            }
        }
    }

    initImages () {
        const $$overlayImages = this.$hotspot.querySelectorAll('[data-overlayimages="root"]');
        if ($$overlayImages.length > 0) {
            import('../hotspot/overlay').then(({ OverlayImages }) => {
                for (let i = 0; i < $$overlayImages.length; i++) {
                    const overlayImagesAPI = new OverlayImages($$overlayImages[i]);
                    $$overlayImages[i].API = overlayImagesAPI;
                }
            });
        }
    }

    showIntro () {
        this.$hotspot.classList.add('is--visible');
        this.loadAndPlayVideo(this.$hotspotIntroMedia);

        if (typeof this.settings.onOverviewLoaded === 'function') {
            this.settings.onOverviewLoaded();
        }
    }

    showOutro ($callback) {
        this.$hotspot.classList.remove('show--intro-marker');

        window.setTimeout(() => {
            this.$hotspot.classList.remove('show--intro-headline');
            this.loadAndPlayVideo(this.$hotspotOutroMedia);
        }, 750);

        window.setTimeout(() => {
            $callback();
        }, 750 + this.$hotspotOutroMedia.duration * 1000);
    }

    showChapterOverview ($currentChapter) {
        this.$hotspot.classList.add('show--chapter');

        for (let i = 0; i < this.$$hotspotChapters.length; i++) {
            $currentChapter.classList.remove('is--in');
            $currentChapter.classList.remove('is--out');
        }

        $currentChapter.classList.add('is--in');

        const $video = $currentChapter.querySelector('[' + this.settings.initAttr + '="' + this.settings.chapterMediaAttr + '"]');

        if ($video !== null) {
            this.loadAndPlayVideo($video);
        }
    }

    hideChapterOverview ($currentChapter) {
        const $currentContent = $currentChapter.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"].is--in');

        if ($currentContent !== null) {
            this.hideChapterContent($currentChapter, $currentContent, false);
        } else {
            $currentChapter.classList.add('is--out');
        }

        window.setTimeout(() => {
            $currentChapter.classList.remove('is--in');
            $currentChapter.classList.remove('is--out');
            $currentChapter.querySelector('video').currentTime = 0;
            this.$hotspot.classList.remove('show--chapter');
            this.showIntro();
        }, 750);
    }

    showChapterContent ($currentChapter, $currentContent) {
        $currentChapter.classList.add('is--out');

        window.setTimeout(() => {
            $currentChapter.querySelector('video').currentTime = 0;
            $currentChapter.classList.add('show--content');
            $currentContent.classList.add('is--in');
        }, 1000);

        window.setTimeout(() => {
            this.loadAndPlayVideo($currentContent.querySelector('video'));
        }, 1500);
    }

    hideChapterContent ($currentChapter, $currentContent, showChapter) {
        $currentContent.classList.add('is--out');

        window.setTimeout(() => {
            $currentContent.classList.remove('is--in');
            $currentContent.classList.remove('is--out');
            $currentChapter.classList.remove('show--content');

            if (showChapter === true) {
                this.showChapterOverview($currentChapter);
            }
        }, 1250);
    }
}

export { Hotspot };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$hotspots = $context.querySelectorAll('[data-hotspot="root"]');

        if ($$hotspots.length > 0) {
            const $header = $context.querySelector('[data-header="root"]');

            for (let i = 0; i < $$hotspots.length; i++) {
                const $hotspot = new Hotspot($$hotspots[i], {
                    breakpoints: window.OPTIONS.breakpoints,
                    header: $header,
                    onOverviewLoaded: () => {
                        window.checkMoodVideo(window.eventScroller);
                    }
                });
                $hotspot.initialize();
            }
        }
    }
});
